<template>
  <Bar
    id="my-chart-bar"
    :options="chartOptions"
    :data="chartData"
    :width="width"
  />
</template>

<script>
import { Bar } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        // type: "bar",
        labels: [
          "TV aberta",
          "Rádio",
          "TV paga",
          "Vídeo sob demanda",
          "Streaming (Áudio)",
          "Shows ao vivo",
          "Música de fundo",
          "Clubes",
          "Cinema",
          ["Música ao vivo", "(pequenas casas de shows)"],
          "Outras",
        ],
        datasets: [
          {
            backgroundColor: [
              "rgba(236,22,81, 1)",
              "rgba(326,22,81, 0.9)",
              "rgba(236,22,81, 0.8)",
              "rgba(236,22,81, 0.7)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.5)",
              "rgba(236,22,81, 0.6)",
              "rgba(236,22,81, 0.5)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.4)",
              "rgba(236,22,81, 0.2)",
              "rgba(236,22,81, 0.4)",
            ],
            data: [
              22.51, 20.43, 18.32, 10.85, 7, 5.84, 5.06, 2.95, 2.44, 1.98, 2.6,
            ],
            borderWidth: 0,
          },
        ],
      },
      chartOptions: {
        indexAxis: 'y',
        scales: {
          y: {
            ticks: { 
              color: '#EC1651', 
              font : {
                size : 12,    
                family: 'sanuk-bold'
              }
            }
          }
        },
        plugins: {
          tooltip: {
            displayColors: true,
            backgroundColor: "#FFF",
            bodyColor: "#000",
            titleColor: " #000",
            padding: 10,
            callbacks: {
              label: (x) => {
                return `${x.formattedValue.replaceAll(".", ",")}%`;
              },
            },
          },
          legend: {
            display: false,
          },
          datalabels: {
            color: 'white',
            formatter: function(value) {
              return  String(value).split('.').join(',') + '%';
            }
          },
        },
        animation: {
          animateScale: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        hoverOffset: 5,
      },
    };
  },
};
</script>
